module.exports = __webpack_public_path__ + "img/avo_miranda.e6633df7.jpg";